export default {
  LARGE_DESKTOP: 1213,
  DESKTOP: 1024,
  TABLET: 768,
  SMARTPHONE_LARGE: 375,
};
